import ame from "../assets/images/flags/africa-middle-east.png";
import australia from "../assets/images/flags/australia.svg";
import benelux from "../assets/images/flags/benelux.svg";
import brazil from "../assets/images/flags/brazil.svg";
import chinaAndHongKong from "../assets/images/flags/china-and-hong-kong.svg";
import es from "../assets/images/flags/es.svg";
import eu from "../assets/images/flags/eu.svg";
import fr from "../assets/images/flags/france.svg";
import ger from "../assets/images/flags/germany.svg";
import scandinavia from "../assets/images/flags/scandinavia.svg";
import singapore from "../assets/images/flags/singapore.svg";
import sa from "../assets/images/flags/south-africa.svg";
import sw from "../assets/images/flags/switzerland.svg";
import uganda from "../assets/images/flags/uganda.svg";
import uae from "../assets/images/flags/united-arab-emirates.svg";
import uk from "../assets/images/flags/united-kingdom.svg";
import usa from "../assets/images/flags/usa.svg";

export const FLAGS: any = {
  es,
  eu,
  benelux,
  fr,
  ger,
  uk,
  sw,
  scandinavia,
  uae,
  ame,
  uganda,
  sa,
  usa,
  brazil,
  australia,
  chinaAndHongKong,
  singapore
};
